import { getAccessToken } from '../utils/access-token/get-access-token';

export const useAccessToken = (): string | null => {
  return getAccessToken();
};
